export default __webpack_public_path__ + "static/media/File No. 13.60c8a2cb.pdf";